// extracted by mini-css-extract-plugin
export var clickableWrapper = "_23-2";
export var placeholderIcon = "_23-3";
export var thumbnailCanvas = "_23-1";
export var thumbnailWrapper = "_23-0";